module.exports = __webpack_public_path__ + "img/triplo-diamante.6bf31399.png";